import getDecryptedToken from "../api/getDecryptedToken";

export function isPrintTemplate2Enabled(): boolean {
  return getDecryptedToken("featurePrintTemplate2") === "true";
}

export function isCertificatePrintEnabled(): boolean {
  return getDecryptedToken("featureCertificatePrint") === "true";
}

export function isDoctorTransferEnabled(): boolean {
  return getDecryptedToken("featureDoctorTransfer") === "true";
}

export function isPromotionalSmsEnabled(): boolean {
  return getDecryptedToken("featurePromotionalSms") === "true";
}

/** Stock, purchases, product release, and selling medicines on the invoice. */
export function isInventoryEnabled(): boolean {
  return getDecryptedToken("featureInventory") === "true";
}

/** Portal cut down to patients and appointments; other flags add modules on top. */
export function isBookMyDentistOnly(): boolean {
  return getDecryptedToken("featureBookMyDentistOnly") === "true";
}

/** Treatment pages and the buttons that open them. Off in BookMyDentist only. */
export function isTreatmentsEnabled(): boolean {
  return !isBookMyDentistOnly();
}

/** Invoices, payments and money figures. Off in BookMyDentist only. */
export function isBillingEnabled(): boolean {
  return !isBookMyDentistOnly();
}
